import { decodeSafeEntities } from '@/lib/sanitise-strings'

export const getTopics = async (): Promise<{ label: string; value: string }[]> => {
  const url = `${process.env.NEXT_PUBLIC_WP_API_URL}/wp-json/wp/v2/all-topics?per_page=100&_fields[]=id&_fields[]=name&_fields[]=slug&_fields[]=acf.group`

  const response = (await fetch(url)) as Response

  if (!response.ok) {
    return null
  }

  const data = await response.json()

  if (!Array.isArray(data) || data?.length === 0) {
    return []
  }

  // Group the choices by the "group" property
  const groupMap = {}

  data.forEach((item) => {
    const groupKey = item.acf?.group || 'generic'

    if (!groupMap[groupKey]) {
      groupMap[groupKey] = {
        title: groupKey,
        choices: [],
      }
    }

    groupMap[groupKey].choices.push({
      label: decodeSafeEntities(item.name),
      value: item.id,
    })
  })

  // Change the "generic" group to "Topics"
  if (groupMap['generic']) {
    groupMap['generic'].title = 'Topics'
  }

  // If keys are present, sort using the below
  const groupOrder = ['markets', 'sectors', 'generic']

  // Return grouped topics sorted by groupOrder
  return Object.values(groupMap).sort((a, b) => {
    const indexA = groupOrder.indexOf(a.title)
    const indexB = groupOrder.indexOf(b.title)

    // Groups not in groupOrder will be sorted last
    if (indexA === -1 && indexB === -1) return 0
    if (indexA === -1) return 1
    if (indexB === -1) return -1

    return indexA - indexB
  })
}
